module.exports = __webpack_public_path__ + "static/img/banner-zryt.753b32f9.png";